export const APP_NAME = "Clarity Bible";
// Google Play listing for the published TWA (package host.emergent.scripture_focus.twa)
export const APP_PLAY_URL = "https://play.google.com/store/apps/details?id=host.emergent.scripture_focus.twa";
